import { useEffect } from 'react';

export const useOnScrollChange = ({
  scrollContainer,
  suppress,
  onChange,
}: {
  scrollContainer: HTMLDivElement | null;
  suppress: boolean;
  onChange: (scrollOffset: number) => unknown;
}) => {
  useEffect(() => {
    if (!scrollContainer) return;

    const handleScroll = () => {
      if (!suppress) onChange(scrollContainer.scrollLeft);
    };

    scrollContainer.addEventListener('scroll', handleScroll);
    return () => scrollContainer?.removeEventListener('scroll', handleScroll);
  }, [scrollContainer, suppress, onChange]);
};
